export const isWindowSizeDownLg = window.innerWidth < 1280
